import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from '../../modules/shared/shared.module';
import { SvgIconComponent } from '../svg-icon/svg-icon.component';
@Component({
  selector: 'app-item-card',
  standalone: true,
  imports: [SharedModule, SvgIconComponent],
  templateUrl: './info-card-banner.component.html',
  styleUrl: './info-card-banner.component.scss'
})
export class InfoCardBannerComponent {
  @Input() title!: string;
  @Input() lines: string[] = [];

  @Input() badges: { label: string; class: string; }[] = [];

  @Input() actions: {
    name: string;
    label?: string;
    icon?: string;
    disabled?: boolean;
    class: string;
  } [] = [];

  @Output() actionClicked = new EventEmitter<string>();


  onActionClicked(action: string) {
    this.actionClicked.emit(action);
  }
}
